import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { CourseResponse } from '../models/courseResponse';

export const getCourse = (courseId: string): Promise<CourseResponse> => {
  return cacheableRequest(`/v1/tasklists/${courseId}`).then(({ data }: AxiosResponse<{ tasklist: CourseResponse }>) => {
    return data.tasklist;
  });
};
